'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _StaticURLField = require('../../../../../components/form/fields/StaticURLField');

var _StaticURLField2 = _interopRequireDefault(_StaticURLField);

var _getAppUrl = require('../../../../../utils/getAppUrl');

var _getAppUrl2 = _interopRequireDefault(_getAppUrl);

var _userConstants = require('../../../../../../common/users/userConstants');

require('./PublicSharingLink.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPublicLink = function getPublicLink(currentBoardId) {
    return (0, _getAppUrl2.default)() + '/' + currentBoardId;
};

var PublicSharingLink = function PublicSharingLink(_ref) {
    var currentBoardId = _ref.currentBoardId,
        unsharePublicBoard = _ref.unsharePublicBoard,
        boardPermissions = _ref.boardPermissions;

    var sharedContext = boardPermissions[_userConstants.PUBLIC_USER_ID].elementId;
    var url = getPublicLink(currentBoardId);
    var showButton = sharedContext === currentBoardId;

    return _react2.default.createElement(
        'div',
        { className: 'PublicSharingLink' },
        _react2.default.createElement(
            'div',
            { className: 'public-link-title' },
            _react2.default.createElement(
                'span',
                null,
                'Link to this board'
            ),
            showButton ? _react2.default.createElement(
                _Button2.default,
                { className: 'link-button', onClickFn: unsharePublicBoard },
                'Turn off'
            ) : null
        ),
        _react2.default.createElement(
            'div',
            { className: 'public-link' },
            _react2.default.createElement(_StaticURLField2.default, { url: url })
        )
    );
};

PublicSharingLink.propTypes = {
    currentBoardId: _propTypes2.default.string,
    unsharePublicBoard: _propTypes2.default.func,
    boardPermissions: _propTypes2.default.object
};

exports.default = PublicSharingLink;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/publicLink/PublicSharingLink.js
// module id = 2195
// module chunks = 0